<template>
  <div class="service">
    <div class="container">
      <div class="query">
        <el-card shadow="always" class="card">
          <el-form :rules="rules" :model="queryParams" ref="mobileForm">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="queryParams.mobile" placeholder="请输入手机号"> </el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="queryParams.code" placeholder="验证码">
                <template slot="suffix">
                  <el-button @click="sendCode" :disabled="codeDisabled" size="mini">
                    {{ codeText }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="agree">
              <el-checkbox v-model="queryParams.agree"> 我已阅读并同意 </el-checkbox>
              <span @click="showPolicy = true" class="link">《隐私保护政策》</span>
            </el-form-item>
            <el-form-item>
              <el-button style="width: 100%" type="primary" @click="onSubmit('mobileForm')">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
    <el-dialog
      title="查询结果"
      center
      :visible="showResult"
      @close="showResult = false"
      :width="isMobile ? '90%' : '600px'"
    >
      <div v-if="cardData.length">
        <div class="result-item" v-for="item in cardData">
          <el-row>
            <el-col :xs="24">质保编码: {{ item.uuid }}</el-col>
            <el-col :xs="24">姓名: {{ item.username }}</el-col>
            <el-col :xs="24">电话: {{ item.mobile }}</el-col>
            <el-col :xs="24">车牌号: {{ item.license }}</el-col>
            <el-col :xs="24">施工日期: {{ item.worked_date }}</el-col>
            <el-col :xs="24">质保期止: {{ item.expired_date }}</el-col>
            <el-col :xs="24">装贴位置: {{ item.sites.map((item) => item.name).join('、') }} </el-col>
            <el-col :xs="24">型号: {{ `${item.series.name}·${item.version.name}` }} </el-col>
          </el-row>
        </div>
      </div>
      <el-result icon="info" title="未查询到相关数据" subTitle="请核验后查询" v-else> </el-result>
    </el-dialog>
    <el-dialog title="隐私保护政策" center :visible="showPolicy" @close="showPolicy = false">
      <div class="content" v-html="policy"></div>
    </el-dialog>
  </div>
</template>

<script>
import { sendSmsCode, queryCard, getPolicyDetail } from '@/api/index'
import { isMobile } from '@/utils'

export default {
  name: 'Warranty',
  data() {
    var validateAgree = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请先阅读并同意《隐私保护政策》'))
      } else {
        callback()
      }
    }
    return {
      isMobile,
      queryParams: {
        mobile: '',
        code: '',
        agree: false
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        agree: [
          { required: true, message: '请先阅读并同意《隐私保护政策》', trigger: 'blur' },
          { validator: validateAgree, trigger: 'blur' }
        ]
      },
      codeText: '发送验证码',
      codeDisabled: false,
      time: 60,
      cardData: {},
      showResult: false,
      showPolicy: false,
      policy: ''
    }
  },
  created() {
    getPolicyDetail()
      .then((res) => {
        this.policy = res.data.content
      })
      .catch((err) => {
        console.log('getPolicyDetail', err)
      })
  },
  methods: {
    sendCode() {
      this.$refs.mobileForm.validateField('mobile', (err) => {
        if (!err) {
          this.codeDisabled = true
          sendSmsCode({ mobile: this.queryParams.mobile })
            .then((res) => {
              this.$message.success('发送成功')
              this.startTimer()
            })
            .catch((err) => {
              console.log('sendSmsCode', err)
              this.$message.error(err.msg || '发送失败')
            })
        }
      })
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
          this.codeText = `${this.time}秒后重新获取`
        } else {
          this.codeDisabled = false
          this.time = 60
          this.codeText = `重新发送`
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 质保查询
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          queryCard({ ...this.queryParams, type: formName })
            .then((res) => {
              this.cardData = res.data
              this.showResult = true
            })
            .catch((err) => {
              console.log(err)
              this.$message.error(err.msg || '查询失败')
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  display: flex;
  justify-content: center;
  background: url('~@/assets/bg_1.jpg') no-repeat center/cover;
}
.container {
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}
.query {
  min-height: calc(100vh - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  .card {
    width: 380px;
    .link {
      color: #409eff;
      cursor: pointer;
      user-select: none;
    }
  }
}

@media screen and (max-width: 991px) {
  .container {
    width: 100%;
  }
  .query {
    .card {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}

.result-item:not(:last-child) {
  margin-bottom: 20px;
}
</style>
